import axios from '@/plugins/axios';

export default {
    namespaced: true,

    actions: {
        // パラメータ設定初期表示取得API
        async getParameters({ state, commit, rootState }: any, data: any) {
            // 通信結果を格納する変数を初期化
            let result: any;

            // API通信を実行
            // URL:GET /api/parameter-settings/init-parameters
            // params:サービスコード
            await axios.get('/api/parameter-settings/init-parameters', {
                params: {
                    serviceCode: data.serviceCode
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // パラメータ設定編集API
        async updateParameters({ state, commit, rootState }: any, data: any) {
            // 通信結果を格納する変数を初期化
            let result: any;

            // API通信を実行
            // URL:PUT /api/parameter-settings/update-parameters
            // params:サービスコード
            //        フォームデータ
            await axios.put('/api/parameter-settings/update-parameters', {
                serviceCode: data.serviceCode,
                forms: data.forms
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        },

        // 組織名称/管理者のみ表示/状態プルダウンデータ取得API
        async getPulldownItems() {
            // 通信結果を格納する変数を初期化
            let result: any;
    
            // API通信を実行
            // URL:GET /api/parameter-settings/pulldown-items
            // params:なし
            await axios.get('/api/parameter-settings/pulldown-items')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });
    
            // 通信結果を返す
            return result;
        },

        // 校種プルダウンデータ取得API
        async getSchoolTypePulldownItems({ state, commit, rootState }: any, data: any) {
            // 通信結果を格納する変数を初期化
            let result: any;
    
            // API通信を実行
            // URL:GET /api/parameter-settings/school-type-pulldown-items
            // params:タブ番号
            await axios.get('/api/parameter-settings/school-type-pulldown-items', {
                params: {
                    selectTab: data.selectTab
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });
    
            // 通信結果を返す
            return result;
        },

        // 教科プルダウンデータ取得API
        async getCurriculumPulldownItems() {
            // 通信結果を格納する変数を初期化
            let result: any;
    
            // API通信を実行
            // URL:GET /api/parameter-settings/curriculum-pulldown-items
            // params:なし
            await axios.get('/api/parameter-settings/curriculum-pulldown-items')
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });
    
            // 通信結果を返す
            return result;
        },

        // カテゴリデータ取得API
        async getCategories({ state, commit, rootState }: any, data: any) {
            // 通信結果を格納する変数を初期化
            let result: any;
    
            // API通信を実行
            // URL:GET /api/parameter-settings/init-categories
            // params:サービスコード
            //        タブ番号
            //        選択した校種ID（教科設定、科目設定以外は空文字）
            //        選択した教科ID（科目設定以外は空文字）
            await axios.get('/api/parameter-settings/init-categories', {
                params: {
                    serviceCode: data.serviceCode,
                    selectTab: data.selectTab,
                    selectSchoolTypePulldown: data.selectSchoolTypePulldown,
                    selectCurriculumPulldown: data.selectCurriculumPulldown
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });
    
            // 通信結果を返す
            return result;
        },

        // カテゴリ削除チェックAPI
        async checkDeleteCategory({ state, commit, rootState }: any, data: any) {
            // 通信結果を格納する変数を初期化
            let result: any;
    
            // API通信を実行
            // URL:GET /api/parameter-settings/check-delete-category
            // params:サービスコード
            //        タブ番号
            //        カテゴリID
            //        選択した校種ID（教科設定、科目設定以外は空文字）
            //        選択した教科ID（科目設定以外は空文字）
            await axios.get('/api/parameter-settings/check-delete-category', {
                params: {
                    serviceCode: data.serviceCode,
                    selectTab: data.selectTab,
                    categoryId: data.categoryId,
                    selectSchoolTypePulldown: data.selectSchoolTypePulldown,
                    selectCurriculumPulldown: data.selectCurriculumPulldown
                }
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });
    
            // 通信結果を返す
            return result;
        },

        // カテゴリ設定登録API
        async processCategories({ state, commit, rootState }: any, data: any) {
            // 通信結果を格納する変数を初期化
            let result: any;

            // API通信を実行
            // URL:PUT /api/parameter-settings/process-categories
            // params:サービスコード
            //        タブ番号
            //        カテゴリ一覧情報
            //        選択した校種ID（教科設定、科目設定以外は空文字）
            //        選択した教科ID（科目設定以外は空文字）
            await axios.put('/api/parameter-settings/process-categories', {
                serviceCode: data.serviceCode,
                selectTab: data.selectTab,
                forms: data.forms,
                selectSchoolTypePulldown: data.selectSchoolTypePulldown,
                selectCurriculumPulldown: data.selectCurriculumPulldown
            })
                .then((response) => {
                    // 通信結果を設定（正常）
                    result = response;
                })
                .catch((error) => {
                    // 通信結果を設定（エラー）
                    result = error.response;
                });

            // 通信結果を返す
            return result;
        }
    }
}
